import { render } from "./page-home.vue?vue&type=template&id=01bf6072"
import script from "./page-home.vue?vue&type=script&lang=js"
export * from "./page-home.vue?vue&type=script&lang=js"

import "./page-home.vue?vue&type=style&index=0&id=01bf6072&lang=scss"

import exportComponent from "/Users/apple/Documents/jmd/Templates/Templates/chatgpt-tpl/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__